export default "__VITE_ASSET__0h0Affbo__"